// Whether an address is on a free mailbox service or a company's own domain: the cheapest sign of a lead's quality,
// sent with step 1 (signup:details_submitted, `email_type`). The list covers the big services; a rare free one counts
// as business, which is the safe side.
const FREE_MAIL_DOMAINS = new Set([
    'gmail.com',
    'googlemail.com',
    'outlook.com',
    'hotmail.com',
    'live.com',
    'msn.com',
    'yahoo.com',
    'ymail.com',
    'icloud.com',
    'me.com',
    'mac.com',
    'aol.com',
    'proton.me',
    'protonmail.com',
    'gmx.com',
    'gmx.de',
    'gmx.net',
    'web.de',
    't-online.de',
    'mail.com',
    'zoho.com',
    'yandex.com',
    'yandex.ru',
    'mail.ru',
    'qq.com',
    '163.com',
]);
// Country variants of the big ones: hotmail.fr, yahoo.co.uk, outlook.es and the like.
const FREE_MAIL_FAMILIES = /^(hotmail|outlook|live|yahoo|gmx)\.[a-z.]+$/;

export function emailType(email: string): 'business' | 'free' {
    const domain = email.trim().toLowerCase().split('@')[1] || '';
    return FREE_MAIL_DOMAINS.has(domain) || FREE_MAIL_FAMILIES.test(domain) ? 'free' : 'business';
}
